module.exports = __webpack_public_path__ + "static/media/js.c5e13bb2.svg";